module.exports = __webpack_public_path__ + "img/letter.a956d51c.svg";